import {
  toastTypes,
  brandConfigurationConstants,
} from "../../constants";
import { customToast } from "../../../../shared";
import { brandConfigurationService } from "../../services";
import {
  success,
  withSpinner,
  failure,
} from "../../../../redux/actions/utilities";

const { BRAND_CONFIGURATION_DATA, REFRESH_BRAND_CONFIGURATION } =
  brandConfigurationConstants;

const getBrandConfiguration = (body) => {
  return (dispatch) => {
    withSpinner(dispatch, BRAND_CONFIGURATION_DATA, () =>
      brandConfigurationService
        .getBrandConfiguration(body)
        .then(
          (response) => {
            dispatch(success(response, BRAND_CONFIGURATION_DATA));
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            dispatch(failure(null, BRAND_CONFIGURATION_DATA));
          },
        )
    );
  };
};

const manageBrandConfiguration = (payload, onCallBack) => {
  return (dispatch) => {
    withSpinner(dispatch, REFRESH_BRAND_CONFIGURATION, () =>
      brandConfigurationService
        .manageBrandConfiguration(payload)
        .then(
          (response) => {
            onCallBack(response ?? null);
          },
          (error) => {
            customToast(error[0], toastTypes.ERROR);
            onCallBack(null);
          },
        )
    );
  };
};

//Exporting mark actions for other files
export const brandConfigurationActions = {
  getBrandConfiguration,
  manageBrandConfiguration,
};
